export const SIDEBAR_NAMES = {
	waDetails: 'waDetails',
	employmentLog: 'employmentLog',
	locationsLog: 'locationsLog',
	assignJobReturn: 'assignJobReturn',
	returnJobDetails: 'returnJobDetails',
	editInfo: 'editInfo',
};
